import { apiFetch } from "utils/api";

function withQuery(path, params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.set(key, String(value));
  });
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}

export async function getControlDevices(params = {}) {
  return apiFetch(withQuery("/api/admin/control/devices", params));
}

export async function getControlDeviceById(deviceId) {
  return apiFetch(`/api/admin/control/devices/${deviceId}`);
}

export async function updateControlDevice(deviceId, payload) {
  return apiFetch(`/api/admin/control/devices/${deviceId}`, {
    method: "PATCH",
    body: payload,
  });
}

export async function createControlDeviceToken(deviceId, payload = {}) {
  return apiFetch(`/api/admin/control/devices/${deviceId}/token`, {
    method: "POST",
    body: payload,
  });
}

export async function queueDeviceCommand(deviceId, payload) {
  return apiFetch(`/api/admin/control/devices/${deviceId}/commands`, {
    method: "POST",
    body: payload,
  });
}

export async function triggerDeviceQuickAction(deviceId, action) {
  return apiFetch(`/api/admin/control/devices/${deviceId}/actions/${action}`, {
    method: "POST",
  });
}

export async function getControlCommands(params = {}) {
  return apiFetch(withQuery("/api/admin/control/commands", params));
}

export async function getControlCommandById(commandId) {
  return apiFetch(`/api/admin/control/commands/${commandId}`);
}

export async function dispatchControlCommand(commandId) {
  return apiFetch(`/api/admin/control/commands/${commandId}/dispatch`, {
    method: "POST",
  });
}

export async function getAdminCustomers() {
  return apiFetch("/api/admin/customers");
}
